import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { useVersion } from "@/lib/api";

import { SECTIONS } from "./how-to-data";

interface SectionSearchProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (sectionId: string) => void;
}

export function SectionSearch({ open, onOpenChange, onSelect }: SectionSearchProps) {
  const { data: version } = useVersion();
  const gatewayOn = Boolean(version?.svc_gateway_enabled);
  const handleSelect = (sectionId: string) => {
    onSelect(sectionId);
    onOpenChange(false);
  };

  return (
    <CommandDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Search How-To Guide"
      description="Search for topics, features, and answers"
    >
      <CommandInput placeholder="Search topics..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        {SECTIONS.map((section) => (
          <CommandGroup key={section.id} heading={section.title}>
            {section.searchItems
              .filter((item) => !item.servicesGatewayOnly || gatewayOn)
              .map((item) => (
                <CommandItem
                  key={`${section.id}-${item.title}`}
                  value={`${item.title} ${item.keywords.join(" ")}`}
                  onSelect={() => handleSelect(section.id)}
                >
                  <section.icon className="text-muted-foreground mr-2 size-4" />
                  <span>{item.title}</span>
                </CommandItem>
              ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
